import moment from 'moment'

const prepareShow = occurrenc => {
  occurrenc.created_at = moment(occurrenc.created_at, 'YYYYMMDD').format('DD/MM/YYYY')
  occurrenc._code = moment(occurrenc.created_at, 'YYYYMMDD').format('DDMMYYYY')
  return occurrenc
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  getTenantUnits (unit) {
    const params = {
      unit_id: unit.unit_id,
      tower_id: unit.tower_id
    }
    this.$http.post('/v1/dweller/unit/tenant/search', params)
      .then((data) => {
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/book-occurrence/index/resources/methods.js